import { useCurrentSite } from '@hotjar/site';
import { segment } from '@hotjar/tracking';
import { DEFAULT_HOTJAR_FILTERS } from '@hotjar/recordings/src/constants/hotjar-filters';

import type { segment as Segment } from '@hotjar/tracking';
import type { HotjarFilters } from '../../../store/list/types';

type ValueOfHotjarFilters = (typeof DEFAULT_HOTJAR_FILTERS)[keyof typeof DEFAULT_HOTJAR_FILTERS];
type TrackingFunction = (hotjarFilters: HotjarFilters) => void;

const TRACK_EVENT = 'Local Filters Applied';

const hasFilterDefaultValue = (
  defaultValue: ValueOfHotjarFilters,
  filterValue: ValueOfHotjarFilters,
) => {
  if (Array.isArray(defaultValue)) {
    return defaultValue.length === filterValue.length;
  }

  return defaultValue === filterValue;
};

const filtersToArray = (filters: HotjarFilters): string[] =>
  Object.entries(filters).map(([key, currentValue]) => {
    const defaultValue = DEFAULT_HOTJAR_FILTERS[key as keyof HotjarFilters];
    const valueToSend = hasFilterDefaultValue(defaultValue, currentValue) ? '' : `${currentValue}`;

    return Array.isArray(valueToSend) ? `${key}:${valueToSend.join(',')}` : `${key}:${valueToSend}`;
  });

export const useLocalFiltersTracking = (): TrackingFunction => {
  const { data: currentSite } = useCurrentSite();

  const trackData: Segment.SegmentTrackData = {
    account_id: currentSite?.account?.id as number,
    organization_id: currentSite?.organization?.id as number,
    site_id: currentSite?.id as number,
    tool: 'Recordings',
    state_event_was_triggered_on: 'playbacks.list',
    url_event_was_triggered_on: window.location.href,
  };

  const mergeFiltersIncludedInBasePayload = (filtersIncluded: string[]) => {
    return { ...trackData, filters_included: filtersIncluded };
  };

  return (filters) => {
    segment.track(TRACK_EVENT, mergeFiltersIncludedInBasePayload(filtersToArray(filters)));
  };
};
